module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.3892/img/callout-blobs.svg"